import React from 'react';
import styled from 'styled-components';
import Theme from '@styles/Theme';
import { CollectionPath } from '@typings/collections.enum';
import { IpostingItem } from '@typings/posting/posting.interface';
import Icon from '@components/dataDisplay/Icons/Icon';

const Item = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px 16px 8px 8px;
  border: 1px solid var(--lineColor);
  border-radius: var(--cardBorderRadius);
  background: var(--cardBackgroundColor);
  box-shadow: ${Theme.shadow.card};
  display: flex;
  align-items: center;
  gap: 8px;

  .title {
    font-weight: 700;
    font-size: 14px;
  }

  .subTitle {
    font-size: 12px;
    color: var(--subTextColor);
  }

  &:hover {
    background-color: var(--inkColor);
    cursor: var(--hoverCursorURL), pointer;
  }
`;

const ThumbImg = styled.img`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: var(--cardBorderRadius);
  object-fit: cover;
`;

type Props = {
  data: IpostingItem;
  handleClick: (arg0: any, string) => void;
};
function NoticeBox({ data, handleClick }: Props) {
  return (
    <Item onClick={() => handleClick(CollectionPath.POSTING, data.id)}>
      {data.thumbnailURL && <ThumbImg src={data.thumbnailURL} alt="" />}
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}
      >
        <div className="title">{data.title}</div>
        {data.subTitle && <div className="subtitle">{data.subTitle}</div>}
      </div>
      <Icon name="RightArrowO" color="var(--subTextColor)" />
    </Item>
  );
}

export default NoticeBox;
